import React from 'react'
import { Checkbox } from '@mui/material'

export default ({ input: { checked, onChange, ...restInput }, meta, ...rest }) => (
  <Checkbox
    {...rest}
    inputProps={restInput}
    onChange={onChange}
    checked={Boolean(checked)}
    color='primary'
  />
)
